import { getConfig } from '@cian/config/browser';
import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState } from '../../../shared/types/redux';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  const context = { httpApi, config, logger };

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, true, context);
}
